import { Response } from 'src/api/types';

export function createBlobs(responses: Response[]) {
  const RESPONSES_PER_BLOB = 4;

  return responses.reduce((blobs: Array<Array<Response>>, response) => {
    const lastBlobIndex = blobs.length - 1;
    const lastBlob = blobs[lastBlobIndex];

    if (!lastBlob) return [[response]];

    return lastBlob.length === RESPONSES_PER_BLOB
      ? [...blobs, [response]]
      : blobs.map((blob, i) => (i === lastBlobIndex ? [...blob, response] : blob));
  }, []);
}
